/* global axios */

import ApiClient from '../ApiClient';

class N8nWorkflows extends ApiClient {
  constructor() {
    super('n8n_workflows', { accountScoped: true });
  }

  // Get all workflows with optional status filter
  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  // Get single workflow
  get(workflowId) {
    return axios.get(`${this.url}/${workflowId}`);
  }

  // Create workflow
  create(payload) {
    return axios.post(this.url, payload);
  }

  // Update workflow
  update(workflowId, payload) {
    return axios.patch(`${this.url}/${workflowId}`, payload);
  }

  // Delete workflow
  delete(workflowId) {
    return axios.delete(`${this.url}/${workflowId}`);
  }

  // Activate workflow
  activate(workflowId) {
    return axios.post(`${this.url}/${workflowId}/activate`);
  }

  // Deactivate workflow
  deactivate(workflowId) {
    return axios.post(`${this.url}/${workflowId}/deactivate`);
  }

  // Execute workflow manually
  execute(workflowId, inputData = {}, conversationId = null) {
    return axios.post(`${this.url}/${workflowId}/execute`, {
      input_data: inputData,
      conversation_id: conversationId,
    });
  }

  // Get workflow executions
  getExecutions(workflowId, limit = 50) {
    return axios.get(`${this.url}/${workflowId}/executions`, {
      params: { limit },
    });
  }

  // Duplicate workflow
  duplicate(workflowId) {
    return axios.post(`${this.url}/${workflowId}/duplicate`);
  }

  // Export workflow as JSON
  export(workflowId) {
    return axios.get(`${this.url}/${workflowId}/export`);
  }

  // Import workflow from JSON
  import(workflowJson, name = null) {
    return axios.post(`${this.url}/import`, {
      workflow_json: workflowJson,
      name,
    });
  }

  // Get available templates
  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }

  // Get available node types
  getNodeTypes() {
    return axios.get(`${this.url}/node_types`);
  }
}

export default new N8nWorkflows();
